import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { format, subMinutes, fromUnixTime } from 'date-fns';
import type { Task } from 'ember-concurrency';
import type EntryModel from 'garaje/models/entry';
import type LocationModel from 'garaje/models/location';
import type { Field } from 'garaje/models/location';
import type ReservationModel from 'garaje/models/reservation';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';

interface DashboardRowComponentSignature {
  Args: {
    checkID: () => void;
    entry: EntryModel;
    eventReports: unknown[];
    fieldOptions: Field[];
    fullDate: boolean;
    location: LocationModel;
    signOutTask: Task<void, [EntryModel]>;
    userType: string;
    additionalFieldsToExclude?: string[];
  };
}

export default class DashboardRowComponent extends Component<DashboardRowComponentSignature> {
  @service declare state: StateService;
  @service declare featureFlags: FeatureFlagsService;

  get visibleFields(): Field[] {
    const fields = this.args.fieldOptions ?? [];
    const additionalExclusions = this.args.additionalFieldsToExclude ?? ['Signed In'];
    const allExclusions = ['Name', ...additionalExclusions];

    return fields.filter((field) => field.show && !allExclusions.includes(field.name));
  }

  @action
  displayReservationTime(reservation: ReservationModel): string {
    if (reservation.isPartialDay) {
      const startTime = fromUnixTime(reservation.startTime);
      const endTime = fromUnixTime(reservation.endTime);
      const start = subMinutes(startTime, this.state.minutesBetweenTimezones(startTime));
      const end = subMinutes(endTime, this.state.minutesBetweenTimezones(endTime));
      return `${format(start, 'h:mmaa')} - ${format(end, 'h:mmaa')}`;
    }
    return 'All day';
  }

  get fieldCount(): number {
    return (this.args.fieldOptions ?? []).filter((field) => field.show).length;
  }
}
